import React from 'react';
import '../../FieldSelectMenu.css';
import './LobbySelectFieldPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import FieldPlayersCount from '../../elements/FieldPlayersCount/FieldPlayersCount';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {GAME_FIELDS} from '../../../configs/fields';

const RANDOM_FIELD_OPTION = {id: null, name: 'Случайное поле'};

function LobbySelectFieldPage({selectedFieldId, onSelectField, onBack}) {
  usePageAnalytics('LobbySelectFieldPage');

  const options = [RANDOM_FIELD_OPTION, ...GAME_FIELDS];

  return (
    <>
      <h1 className="menu-title">Выбор поля</h1>

      <div className="field-buttons-container">
        {options.map((field) => {
          const isSelected = (field.id || null) === (selectedFieldId || null);
          return (
            <PageButton
              key={field.id || 'random'}
              className={`field-select-button lobby-field-select-button ${isSelected ? 'lobby-field-select-button_selected' : ''}`}
              onClick={() => onSelectField(field.id)}
              pageId="LobbySelectFieldPage"
              buttonId={field.id || 'random'}
            >
              <span className="field-select-button-name">{field.name}</span>
              <FieldPlayersCount playersCount={field.playersCount}/>
              {isSelected && (
                <img className="lobby-field-select-check" src="/img/icons/check.png" alt="Выбрано"/>
              )}
            </PageButton>
          );
        })}
      </div>

      <div className="main-menu-buttons">
        <PageButton
          className="main-menu-button" onClick={onBack} pageId="LobbySelectFieldPage" buttonId="back"
        >Назад</PageButton>
      </div>
    </>
  );
}

export default LobbySelectFieldPage;
